import { FC, ReactNode } from 'react';
import { BoxProps, Stack, StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { UseFormReturn } from 'react-hook-form';
import { IOrderTypeDescription } from '../../../pages/order/edit/states/orderDetails/orderDetails.state.ts';
import { EmailTrackingByDocumentQueryVariables } from '../../../graphql/generatedModel.ts';
import { LeftColumn } from './components/leftColumn/leftColumn.component.tsx';
import { RightColumn } from './components/rightColumn/rightColumn.component.tsx';
import { AdditionalColumn } from './components/additionalColumn/additionalColumn.component.tsx';

export const InfoBlock: FC<TInfoBlock> = ({
  register,
  addressNameField,
  rightColumn,
  customerName,
  leftColumnProps,
  rightColumnProps,
  infoTip,
  addressValue,
  isEmailServiceForInvoice,
  readOnlyAddress,
  orderType,
  emailTip,
  isNotePinned,
  isAddressPinned,
  ...props
}) => {
  return (
    <SWrapper minHeight={124} direction='row' justifyContent='space-between' {...props}>
      <LeftColumn
        {...{
          customerName,
          infoTip,
          emailTip,
          orderType,
          isEmailServiceForInvoice,
          register,
          addressNameField,
          addressValue,
          readOnlyAddress,
          leftColumnProps,
          isAddressPinned,
        }}
      />
      <RightColumn
        {...{
          rightColumn,
          rightColumnProps,
          isNotePinned,
          isAddressPinned,
        }}
      />
      <AdditionalColumn
        {...{
          isNotePinned,
          isAddressPinned,
        }}
      />
    </SWrapper>
  );
};

const SWrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: `${theme.palette.lightBlue.main}10`,
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: 16,
}));

export interface IInfoBlockCommon extends StackProps {
  customerName: string;
  rightColumn?: ReactNode;
  leftColumnProps?: BoxProps;
  rightColumnProps?: BoxProps;
  infoTip?: {
    text?: string | null;
    readonly?: boolean;
    customerId?: string;
  };
  emailTip?: {
    params: EmailTrackingByDocumentQueryVariables;
    message: string;
  };
  isNotePinned?: boolean;
  isAddressPinned?: boolean;
}

type TInfoBlockForm = IInfoBlockCommon & {
  register?: UseFormReturn<any>['register'];
  addressNameField?: string;
  addressValue?: never;
  isEmailServiceForInvoice?: boolean;
  readOnlyAddress?: boolean;
  orderType?: IOrderTypeDescription;
};
type TInfoBlockNoForm = IInfoBlockCommon & {
  register?: never;
  addressNameField?: never;
  addressValue?: string;
  isEmailServiceForInvoice?: boolean;
  readOnlyAddress?: boolean;
  orderType?: IOrderTypeDescription;
};

export type TInfoBlock = TInfoBlockForm | TInfoBlockNoForm;
